import { useState } from 'react';
import UserList from './UserList';

function UserView() {
  const [refresh, setRefresh] = useState(false);

  const handleSave = () => {
    setRefresh(!refresh);
  };

  return (
    <div className="container mx-auto tw-px-6 tw-pb-6">
      <UserList key={refresh} />
    </div>
  );
}

export default UserView;
